import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import InputField from '../../../Components/InputField';
import GenericPopup from '../../../Components/GenericPopup';
import SelectField from '../../../Components/SelectField';
import { generateInitialValues, generateValidationSchema } from '../formGenerator';
import FileUpload from '../../../Components/FileUpload';
import Confirm from '../../../Components/confirm';
import ToastManager from '../../../Components/ToastManager';
import BusyLoader from '../../../Components/BusyLoader';
import { CommonUtil } from '../../../utils/CommonUtil';
import { NetworkManager } from '../../../Components/NetworkManager';
import { Constants } from '../../Languages/Constants';
import { StatusCodeUtil } from '../../../utils/StatusCodeUtil';
import ImageModal from '../../../Components/ImageModal';
import ImageLoaderNew from '../../../Components/ImageLoaderNew';

const TaskNewRelease = ({ tasks, onClose, data, onCompletionUpdate, onProcessComplete, getAllProcesses, isNoPendingProcess }: any) => {
  const orgId = CommonUtil.getSaasOrgId();
  const [popupInfo, setPopupInfo] = useState<any>(null);
  const [currentScreenIndex, setCurrentScreenIndex] = useState(0);
  const [startTime, setStartTime] = useState<string | null>(null);
  const [orderedImageUrls, setOrderedImageUrls] = useState<any>([]);
  const [startIndex, setStartIndex] = useState<number>(0);
  const [imageFiles, setImageFiles] = useState<any>({});
  const [imageSrc, setImageSrc] = useState<any>("");
  const [galleryPop, setGalleryPop] = useState(false);
  const [allValues, setAllValues] = useState<any>({});
  const fileInputRef = useRef<HTMLInputElement>(null);

  const taskGroups = tasks?.taskGroups || [];
  const currentTaskGroup = taskGroups[currentScreenIndex];
  
  const onLoginError = (err: any) => {
    console.log(err);
  };

  useEffect(() => {
  if (data?.processId) {
    const now = new Date().toISOString();
    setStartTime(now);
    setAllValues({});
  }
  }, [data?.processId]);

  useEffect(()=>{
    if(popupInfo === null){
      setOrderedImageUrls([]);
    }
  }, [popupInfo]);
  
  useEffect(() => {
    setCurrentScreenIndex(0);
  }, [tasks]);
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...generateInitialValues(currentTaskGroup),
      ...allValues,
    },
    validationSchema: generateValidationSchema(currentTaskGroup),
    onSubmit: (values) => {
      setAllValues((prev: any) => ({
        ...prev,
        ...values,
      }));

      if (currentScreenIndex < taskGroups.length - 1) {
        handleNext();
      } else {
        onSaveProcessDetails({ ...allValues, ...values });
      }
    },
  });

  const onSaveProcessDetails = (finalValues: any) => {
    const formattedTasks: any[] = [];

    taskGroups.forEach((group: any) => {
      group.tasks.forEach((task: any) => {
        const taskKey = `task_${task.taskId}`;
        const taskValues = finalValues[taskKey] || {};

        const payload: any = {
          taskId: task.taskId,
          taskType: task.taskType,
          viewType: group.viewType,
        };

        Object.keys(taskValues).forEach((key) => {
          if (key === 'imagePath') {
            payload[key] = Array.isArray(taskValues[key]) ? taskValues[key] : [taskValues[key]];
          } else {
            payload[key] = taskValues[key];
          }
        });

        formattedTasks.push(payload);
      });
    });

    const finalPayload = {
      orgId,
      tasks: formattedTasks,
      endTime: new Date().toISOString(),
      docTypeId: data?.docTypeId,
      processId: data?.processId,
      documentId: data?.documentId,
      startTime: startTime || new Date().toISOString(),
      isInterchangeEnabled: data?.isInterchangeEnabled,
    };

    console.log("Final Payload:", finalPayload);
    const url = `api/inspection/v2/save-event?orgId=${orgId}`;
    NetworkManager.sendJsonRequest(url, finalPayload, "", "POST", true, (dataObj: any) => {
      if (dataObj) {
        var restData = JSON.parse(dataObj);
        if (restData?.status == "SUCCESS") {
          getAllProcesses();
          onProcessComplete();
        }
      }
    }, onLoginError);
  };

  useEffect(() => {
    if (!tasks?.taskGroups || tasks.taskGroups.length === 0) return;

    let completed = 0;

    tasks.taskGroups.forEach((group: any) => {
      group.tasks.forEach((task: any) => {
        const taskKey = `task_${task.taskId}`;
        const taskValues = formik.values[taskKey];
        const taskErrors = formik.errors[taskKey];

        const hasValue =
          taskValues && Object.values(taskValues).some(val => val !== '' && val !== null && val !== undefined);
        const hasError = taskErrors && Object.keys(taskErrors).length > 0;

        if (hasValue && !hasError) {
          completed += 1;
        }
      });
    });

    const tasksList = Object.keys(allValues);
    const count = tasksList.length;

    if (typeof onCompletionUpdate === 'function') {
      onCompletionUpdate(completed);
    }
  }, [formik.values, formik.errors, tasks, allValues]);

  const handleNext = () => {
    if (currentScreenIndex < taskGroups.length - 1) {
      setCurrentScreenIndex(currentScreenIndex + 1);
    }
  };
  
  const imgDesPopUp = (item: any) => {
    setPopupInfo({ type: 'ImgDes', taskId: item.taskId, taskName: item?.taskName, isMultiPicture: item?.isMultiPicture })
  }

  const onUpload = (files: any) => {
    const imageList = files instanceof FileList ?  Array.from(files) :  Array.isArray(files) ? files : [files];
    
    const imageKey = getImageKeyForTask(popupInfo?.taskId);
    const taskKey = `task_${popupInfo?.taskId}`;
    const fullKey = `${taskKey}.${imageKey}`;

    setOrderedImageUrls([]);
    formik.setFieldValue(fullKey, popupInfo?.isMultiPicture ? [] : '', true);
    
    BusyLoader.showLoader();
    let completedUploads = 0;
    const uploadedUrls: string[] = [];
    
    imageList.forEach((file: any) => {
      if (!file) {
        completedUploads++;
        checkCompletion();
        return;
      }
      
      const imgName = file?.name;
      const imgPath = `interchange/task/image/${orgId}/${imgName}-${new Date().getTime()}`;
      const qParam = `objectPath=${imgPath}`;
      NetworkManager.sendJsonRequest("api/session/uploadUrl", "", qParam, "GET", false, (dataObj: any) => {
        if (dataObj?.statusCode) {
            ToastManager.showToast(dataObj.errorMessage, "Error");
            completedUploads++;
            checkCompletion();
            return;
          }
        const strUploadPath = dataObj;
        const myHeaders = new Headers();
        const requestOptions: any = {
          method: "PUT",
          headers: myHeaders,
          body: file,
          redirect: "follow",
        };

        fetch(strUploadPath, requestOptions)
          .then((response) => {
            if (!response.ok) throw new Error("Upload failed");
            uploadedUrls.push(imgPath);
          })
          .catch((error) => {
            console.log("Upload error", error);
            ToastManager.showToast("File upload failed", "Error");
          })
          .finally(() => {
            completedUploads++;
            checkCompletion();
          });
      }, 
      (error: any) => {
        console.log("Error getting upload URL", error);
        completedUploads++;
        checkCompletion();
      });
    });

    function checkCompletion() {
      if (completedUploads === imageList.length) {
        if (popupInfo?.isMultiPicture) {
          formik.setFieldValue(fullKey, uploadedUrls, true);
        } else {
          formik.setFieldValue(fullKey, uploadedUrls.length > 0 ? [uploadedUrls[0]] : [], true);
        }

        BusyLoader.hideLoader();
        formik.setFieldTouched(fullKey, true, true);
        setTimeout(() => {
          formik.validateField(fullKey);
        }, 0);
      }
    }
  };

  const getFieldError = (taskId: number, field: string) => {
    const key = `task_${taskId}`;
    const touched = formik.touched as Record<string, any>;
    const errors = formik.errors as Record<string, any>;

    return errors[key]?.[field];
  };

  const getImageKeyForTask = (taskId: number) => {
    const task = currentTaskGroup?.tasks?.find((t: any) => t.taskId === taskId);
    return task?.imageFilePathKey || "imagePath";
  };
  
  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFinalSubmit = () => {
    const url = `api/inspection/v2/complete?dependentDocTypeId=${data?.docTypeId}&documentId=${data?.documentId}`;
    NetworkManager.sendJsonRequest(url, "", "", "POST", true, (dataObj: any) => {
      if (dataObj) {
        var restData = JSON.parse(dataObj);
        if (restData?.errorMessage) {
          ToastManager.showToast(restData.errorMessage, "Error");
        }else{
          onClose();
        }
      }
    }, onLoginError);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="col-lg-12 mb-2 px-3" style={{height: `${window.innerHeight - 195}px`, overflowY: "scroll", overflowX: "hidden"}}>
        <div className='d-flex justify-content-start mb-3'>
          {currentScreenIndex !== 0 && (
            <i role='button' className="fa-solid fa-arrow-left text-center mt-1 me-2" title='back' onClick={() => setCurrentScreenIndex(prev => prev - 1)}></i>
          )}
          <h6 className="mx-0 mt-1 pb-2">
            {currentTaskGroup?.viewType} - {currentTaskGroup?.tasks?.length}
          </h6>
        </div>

        {currentTaskGroup?.tasks?.map((item: any, i: number) => {
          const taskKey = `task_${item.taskId}`;
          
          return (
            <div className="col-lg-12" key={i}>
              <div className="col-lg-12 d-flex mt-2 mb-0" style={{ border: '1px solid #dee2e6', minHeight: "50px" }}>
                <div className={`${
                  item?.taskStatuses.length === 1 ? 'col-lg-8' : 
                  item?.taskStatuses.length === 2 ? 'col-lg-6' : 
                  item?.taskStatuses.length === 3 ? 'col-lg-4' : 'col-lg-10'} p-2 switch-title`}>
                  <h6 className={`${item.taskName?.length > 95 ? "text-truncate ms-0 mb-1" : ""}`} 
                    title={item.taskName?.length > 95 && item.taskName}
                    style={{maxWidth: item.taskName?.length > 95 ? "340px" : "none", overflowWrap: "break-word"}}>{item?.taskName}</h6>
                  <span className="py-2" style={{minWidth: "100px", maxWidth: "300px", overflowWrap: "break-word"}}>{item?.taskDescription}</span>
                </div>
                {item?.taskStatuses.length > 0 && (
                  <div className={`${item.taskStatuses.length === 2 ? 'col-lg-4' : item?.taskStatuses.length === 3 ? 'col-lg-6' : 'col-lg-2'} switch-field border-start`} style={{ borderBottom: getFieldError(item.taskId, "status") ? "1px solid red" : "none" }}>
                    {item.taskStatuses.length > 1 ? (
                      item.taskStatuses.map((status: string, index: number) => (
                        <div
                          key={index}
                          role="button"
                          className={`${item.taskStatuses.length === 2 ? 'col-lg-6' : item?.taskStatuses.length === 3 ? 'col-lg-4' : 'col-lg-2'} px-1 d-flex justify-content-center align-items-center ${index === 1 ? "border-start" : ""}`}
                          style={{
                            backgroundColor:
                              index === 0
                                ? formik.values[`task_${item.taskId}`]?.[item.statusKey] === status ? "#d4edda" : "transparent"
                                : index === 1
                                ? formik.values[`task_${item.taskId}`]?.[item.statusKey] === status ? "#f8d7da" : "transparent"
                                : formik.values[`task_${item.taskId}`]?.[item.statusKey] === status ? "#829aa9ff" : "transparent",
                            padding: "4px"
                          }}
                        >
                          <input
                            type="radio"
                            id={`radio-${taskKey}-${index}`}
                            name={`${taskKey}.${item.statusKey}`}
                            value={status}
                            checked={formik.values[taskKey]?.[item.statusKey] === status}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          <label htmlFor={`radio-${taskKey}-${index}`} role='button'
                            style={{
                              backgroundColor: item.taskStatuses.length === 2
                                ? (index === 0
                                    ? (formik.values[taskKey]?.[item.statusKey] === status ? "#d4edda" : "transparent")
                                    : index === 1
                                    ? (formik.values[taskKey]?.[item.statusKey] === status ? "#f8d7da" : "transparent")
                                    : (formik.values[taskKey]?.[item.statusKey] === status ? "#829aa9ff" : "transparent"))
                                : "transparent",
                              overflowWrap: "break-word",
                            }}>
                            {status}
                          </label>
                        </div>
                      ))
                    ) : (
                      <div className="col-lg-12 d-flex justify-content-center align-items-center " style={{ padding: "4px", backgroundColor: formik.values[taskKey]?.[item.statusKey] ? "#d4edda" : "transparent" }}>
                        <input
                          type="checkbox"
                          id={`checkbox-${taskKey}`}
                          name={`${taskKey}.${item.statusKey}`}
                          checked={formik.values[taskKey]?.[item.statusKey] === item.taskStatuses[0]}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `${taskKey}.${item.statusKey}`,
                              e.target.checked ? item.taskStatuses[0] : '',
                              true
                            );
                          }}
                          onBlur={formik.handleBlur}
                        />
                        <label htmlFor={`checkbox-${taskKey}`} className="ms-2" role='button' 
                          style={{ backgroundColor: formik.values[taskKey]?.[item.statusKey] ? "#d4edda" : "transparent"}}>
                          {item.taskStatuses[0]}
                        </label>
                      </div>
                    )}
                  </div>
                )}
                <div className="col-lg-2 d-flex justify-content-evenly align-items-center me-3 border-start">
                  <span role="button" title="Description" onClick={()=>imgDesPopUp(item)}>
                    <i className={`fa-regular fa-file-lines mx-2 ${getFieldError(item.taskId, "description") ? "text-danger": ""}`} style={{ color: 'gray', fontSize: '18px' }}></i>
                  </span>
                  <span role="button" title="Upload Image" onClick={()=>imgDesPopUp(item)}>
                    <i className={`fa-solid fa-image mx-3 ${getFieldError(item.taskId, "imagePath") ? "text-danger": ""}`} style={{ color: 'gray', fontSize: '18px' }}></i>
                  </span>
                </div>
              </div>
              <div className='col-lg-12 mb-1 mt-0'>
                <div className={`col-lg-12 ${["Picture List", "List View"].includes(currentTaskGroup?.viewType) ? "" : 'border border-top-0'}`}>
                  <div className='col-lg-12 d-flex ps-2'>
                    <small className="me-2 text-danger">
                      {getFieldError(item.taskId, "status")}
                    </small>
                    <small className="me-2 text-danger">
                      {getFieldError(item.taskId, "description")}
                    </small>
                    <small className="me-2 text-danger">
                      {getFieldError(item.taskId, "imagePath")}
                    </small>
                  </div>
                  {item?.taskType === "Reefer" && (
                  <div className='col-lg-12 pb-2 pt-4 px-3'>
                    <div className='row'>
                      <div className={`col-lg-4 ${item?.presetValueRequired ? "" : "d-none"}`}>
                        <InputField
                          type="text"
                          name={`task_${item.taskId}.presetValue`}
                          placeholder="Preset Value"
                          value={formik.values?.[`task_${item.taskId}`]?.presetValue || ''}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />       
                          <small className="ms-2 text-danger">
                            {getFieldError(item.taskId, "presetValue")}
                          </small>              
                      </div>
                      <div className={`col-lg-4 ${item?.tempratureValueReuired ? "" : "d-none"}`}>
                        <InputField
                            type="text"
                            name={`task_${item.taskId}.tempratureValue`}
                            placeholder="Temperature Value"
                            value={formik.values?.[`task_${item.taskId}`]?.tempratureValue || ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />       
                        <small className="ms-2 text-danger">
                          {getFieldError(item.taskId, "tempratureValue")}
                        </small>              
                      </div>
                      <div className={`col-lg-4 ${item?.hoursValueReuired ? "" : "d-none"}`}>
                        <InputField
                            type="text"
                            name={`task_${item.taskId}.hoursValue`}
                            placeholder="Hours Value"
                            value={formik.values?.[`task_${item.taskId}`]?.hoursValue || ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />       
                          <small className="ms-2 text-danger">
                            {getFieldError(item.taskId, "hoursValue")}
                          </small>              
                      </div>
                    </div>
                  </div>)}
                  {item?.taskType === "Tyre" && (
                  <div className='col-lg-12 px-3 pt-1'>
                    <div className='row pb-3 pt-4'>
                      <div className="col-lg-4">
                        <SelectField
                          name={`task_${item.taskId}.tyreBrand`}
                          placeholder="Tyre Brand"
                          className="form-select"
                          value={formik.values?.[`task_${item.taskId}`]?.tyreBrand || ''}
                          onChange={formik.handleChange}
                        >
                          <option value="" disabled>Select</option>
                          {item?.tyreBrands?.map((brand: any, i: number) => (
                            <option key={i} value={brand?.value}>
                              {brand?.label}
                            </option>
                          ))}
                        </SelectField>  
                        <small className="ms-2 text-danger">
                          {getFieldError(item.taskId, "tyreBrand")}
                        </small>
                      </div>
                      <div className="col-lg-4">
                        <SelectField
                          name={`task_${item.taskId}.tyreSize`}
                          placeholder="Tyre Size"
                          className="form-select"
                          value={formik.values?.[`task_${item.taskId}`]?.tyreSize || ''}
                          onChange={formik.handleChange}
                        >
                          <option value="" disabled>Select</option>
                          {item?.tyreSizes?.map((size: any, i: number) => (
                            <option key={i} value={size?.value}>
                              {size?.value}
                            </option>
                          ))}
                        </SelectField>    
                        <small className="ms-2 text-danger">
                          {getFieldError(item.taskId, "tyreSize")}
                        </small>     
                      </div>
                      <div className="col-lg-4">
                        <SelectField
                          name={`task_${item.taskId}.tyreDepth`}
                          placeholder="Tyre Depth"
                          className="form-select"
                          value={formik.values?.[`task_${item.taskId}`]?.tyreDepth || ''}
                          onChange={formik.handleChange}
                        >
                          <option value="" disabled>Select</option>
                          {item?.tyreDepths?.map((depth: any, i: number) => (
                            <option key={i} value={depth?.value}>
                              {depth?.value}
                            </option>
                          ))}
                        </SelectField>       
                        <small className="ms-2 text-danger">
                          {getFieldError(item.taskId, "tyreDepth")}
                        </small>         
                      </div>
                    </div>
                    <div className='row py-1'>
                      <div className="col-lg-6">     
                        <SelectField
                          name={`task_${item.taskId}.tyreStatus`}
                          placeholder="Tyre Status"
                          className="form-select"
                          value={formik.values?.[`task_${item.taskId}`]?.tyreStatus || ''}
                          onChange={formik.handleChange}
                        >
                          <option value="" disabled>Select</option>
                          {item?.tyreStatuses?.map((brand: string, i: number) => (
                            <option key={i} value={brand}>
                              {brand}
                            </option>
                          ))}
                        </SelectField>       
                        <small className="ms-2 text-danger">
                          {getFieldError(item.taskId, "tyreStatus")}
                        </small>                 
                      </div>
                      <div className="col-lg-6">
                        <SelectField
                          name={`task_${item.taskId}.tyreCondition`}
                          placeholder="Tyre Condition"
                          className="form-select"
                          value={formik.values?.[`task_${item.taskId}`]?.tyreCondition || ''}
                          onChange={formik.handleChange}
                        >
                          <option value="" disabled>Select</option>
                          {item?.tyreConditions?.map((brand: string, i: number) => (
                            <option key={i} value={brand}>
                              {brand}
                            </option>
                          ))}
                        </SelectField>       
                        <small className="ms-2 text-danger">
                          {getFieldError(item.taskId, "tyreCondition")}
                        </small>                        
                      </div>             
                    </div>
                  </div>)}
                  {item?.taskType === "Light" && (item?.lightTypes?.length > 0 || item?.isLightCountRequired === true) && (
                  <div className='col-lg-12 pt-1 px-3 '>
                    <div className='row pb-3 pt-4'>
                      <div className={`col-lg-6 ${item?.lightTypes?.length > 0 ? "" : "d-none"}`}>
                        <SelectField
                          name={`task_${item.taskId}.lightType`}
                          placeholder="Light Type"
                          className="form-select"
                          value={formik.values?.[`task_${item.taskId}`]?.lightType || ''}
                          onChange={formik.handleChange}
                        >
                          <option value="" disabled>Select</option>
                          {item?.lightTypes?.map((brand: string, i: number) => (
                            <option key={i} value={brand}>
                              {brand}
                            </option>
                          ))}
                        </SelectField>       
                        <small className="ms-2 text-danger">
                          {getFieldError(item.taskId, "lightType")}
                        </small>             
                      </div>
                      <div className={`col-lg-6 ${item?.isLightCountRequired === true ? "" : "d-none"}`}>
                        <InputField
                          type="text"
                          name={`task_${item.taskId}.lightCount`}
                          placeholder="Light Count"
                          value={formik.values?.[`task_${item.taskId}`]?.lightCount || ''}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        /> 
                        <small className="ms-2 text-danger">
                          {getFieldError(item.taskId, "lightCount")}
                        </small>       
                      </div>        
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="col-12 text-end pe-4 py-3 border-top">
        <button type="submit" className="btn-green me-3">
          {currentScreenIndex < taskGroups.length - 1 ? 'Next' : 'Submit Process Details'}
        </button>
        <button type="button" disabled={isNoPendingProcess === false} onClick={handleFinalSubmit} className="btn-green">Final Submit</button>
      </div>
      {popupInfo?.type === 'ImgDes' && (
        <GenericPopup
          className="img-modal"
          header={popupInfo?.taskName}
          mode={popupInfo?.type === 'ImgDes'}
          onClose={() => {
            setPopupInfo(null);
            setImageFiles({});
            setImageSrc("");
            setOrderedImageUrls([]);
          }}
          size="sm"
        >
          <>
          <div style={{minHeight: "200px"}}>
            <div className='my-2'>
              <InputField
                type="text"
                name={`task_${popupInfo?.taskId}.description`}
                placeholder="Description"
                style={{minHeight: "80px"}}
                value={formik.values[`task_${popupInfo?.taskId}`]?.description || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              <small className='text-danger mx-2 d-block fw-200'>
                {typeof formik.errors[`task_${popupInfo?.taskId}`] === 'object' && formik.errors[`task_${popupInfo?.taskId}`] !== null
                  && typeof (formik.errors[`task_${popupInfo?.taskId}`] as any).description === 'string'
                  ? (formik.errors[`task_${popupInfo?.taskId}`] as any).description
                  : ''}
              </small>
            </div>
            <div className={`mt-3`}>
              <div className="my-2 ms-1 me-2">
                <label className='fsw-300 my-1'>Add photo evidence</label>
                <div onClick={triggerFileInput}>
                  <input
                    type="file"
                    accept=".jpg,.jpeg,.png"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    multiple={popupInfo?.isMultiPicture}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      const files = popupInfo?.isMultiPicture ? e.currentTarget.files : e.currentTarget.files?.[0];
                      if (files) {
                        onUpload(files);
                      }
                      const imageKey = getImageKeyForTask(popupInfo?.taskId);
                      formik.setFieldTouched(`task_${popupInfo?.taskId}.${imageKey}`, true);
                    }}
                    className="form-control"
                  />
                  <div role='button' className='py-2 px-5 border border-2 rounded fst-700 bg-light'>
                    <img src="../../images/upload.svg" className='ms-3' alt="edit" width={20} height={20}  />
                    <span className='fwt-700 ms-1'>Upload Photo</span>
                  </div>
                </div>
                <small className="ms-2 text-danger">
                  {getFieldError(popupInfo?.taskId, getImageKeyForTask(popupInfo?.taskId))}
                </small>
              </div>
              <div className={` px-2`} style={{ height: "100px"}}>
              {formik.values?.[`task_${popupInfo?.taskId}`]?.[getImageKeyForTask(popupInfo?.taskId)] && (
                  <div className="d-flex mb-2 mt-1" style={{ overflowX: "auto", gap: "10px" }}>
                    {popupInfo?.isMultiPicture ?
                    <>
                      {formik.values?.[`task_${popupInfo?.taskId}`]?.[getImageKeyForTask(popupInfo?.taskId)]?.map((img: any, index: any)=>(
                        <div key={index} className="image-card" 
                          >
                          <div role="button" style={{ position: "relative", width: "80px" , minHeight: "80px"}} onClick={() => {setGalleryPop(true); setStartIndex(index);}}>
                            <ImageLoaderNew
                              key={`${img}-${index}`}
                              path={img}
                              index={index}
                              onLoad={(_: number, url: string) => {
                                setOrderedImageUrls((prev: any) => {
                                  const alreadyExists = prev.some((item: any) => item.key === img);
                                  if (alreadyExists) return prev;

                                  return [...prev, { key: img, original: url }];
                                });
                              }}
                            />
                          </div>
                      </div>))}
                    </>: <div role="button" style={{ position: "relative" }} onClick={() => {setGalleryPop(true);}}>
                          <ImageLoaderNew
                            key={`${popupInfo?.taskId}`}
                            path={formik.values?.[`task_${popupInfo?.taskId}`]?.[getImageKeyForTask(popupInfo?.taskId)]}
                            index={popupInfo?.taskId}
                            onLoad={(_: number, url: string) => {
                              setImageSrc(url)
                            }}
                          />
                        </div>}
                    {/* <button
                      type="button"
                      title="Delete"
                      className="img-close-btn"
                      onClick={() => removeFile("image")}
                    >
                      <img src={"../../images/cancel.svg"} alt="cancel" width={12} height={12} />
                    </button> */}
                  </div>)}
              </div>
            </div>
          </div>
            <div className="text-end mt-2">
              <button type="button" className="btn-primary" onClick={() => setPopupInfo(null)}>Save</button>
            </div>
            {galleryPop && ( 
              <ImageModal
                isOpen={galleryPop}
                imageSrcs={popupInfo?.isMultiPicture ? orderedImageUrls : [imageSrc]}
                startIndex={startIndex}
                caption={imageFiles?.name}
                onClose={() => setGalleryPop(false)}
              />)}
          </>
        </GenericPopup>
      )}
    </form>
  );
};

export default TaskNewRelease;